"use client";

import React from "react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function CtaFinal() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="222217" id="cta-final" className="bg-background text-foreground relative overflow-hidden py-24 md:py-32 lg:py-40">
      <div className="absolute inset-0 pointer-events-none" style={{
      backgroundImage: "url(https://fulcro.mx/wp-content/uploads/2026/04/fulcro-textura-fulcrums-dark.svg)",
      backgroundRepeat: "repeat",
      backgroundSize: "440px",
      opacity: 0.5,
      maskImage: "radial-gradient(ellipse at center, black 0%, transparent 78%)",
      WebkitMaskImage: "radial-gradient(ellipse at center, black 0%, transparent 78%)"
    }} aria-hidden="true" />
      <div className="container relative z-10 mx-auto px-4 sm:px-6 lg:px-8">
        <div ref={ref} className={`mx-auto max-w-3xl text-center transition-all duration-1000 ease-out ${isVisible ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0"}`}>
          <h2 className="font-serif text-4xl font-normal text-foreground sm:text-5xl lg:text-6xl leading-tight">
            Hablemos.
          </h2>
          <p className="mt-6 text-lg leading-relaxed text-muted-foreground sm:text-xl font-sans">
            Una llamada de 30 minutos para entender tu operación. Si hay fit, seguimos. Si no, te queda claridad sobre el siguiente paso.
          </p>
          <div className="mt-10 flex flex-col items-center justify-center gap-4 sm:flex-row">
            <Link to="/ContactPage">
              <Button size="lg" className="h-14 px-8 text-base font-medium bg-primary text-primary-foreground hover:bg-primary/90 rounded-sm transition-colors">
                Agendar 30 minutos →
              </Button>
            </Link>
          </div>

          <div className="mt-16 flex flex-col items-center justify-center">
            <span className="font-mono text-xs uppercase tracking-wider text-muted-foreground">
              Partners oficiales de:
            </span>
            <div className="mt-6 flex flex-wrap items-center justify-center gap-6 sm:gap-8">
              <Link className="h-8 md:h-10 w-auto object-contain cursor-pointer" href="https://www.make.com/en/register?pc=jorgecastromx" newTab>
                <img src="https://fulcro.mx/wp-content/uploads/2026/10/701741_custom_site_themes_id_MgJYMKKoSiOnJ5JqnOrb_image-19-1-1.png" alt="Make Partners" loading="lazy" className="h-8 md:h-10 w-auto object-contain" />
              </Link>
              <Link className="h-10 md:h-12 w-auto object-contain underline cursor-pointer" href="https://www.kommo.com/es/" newTab><img src="https://fulcro.mx/wp-content/uploads/2026/10/Badge-light-1.svg" alt="Kommo Partner" loading="lazy" className="h-10 md:h-12 w-auto object-contain" /></Link>
            </div>
          </div>
        </div>
      </div>
    </section>;
}